import React, { useMemo, useState } from 'react';
import { Form, InputNumber, Typography } from 'antd';
import { currencyInputProps, decimalInputProps } from '../../../utils/numberInputMask';
import { simularAvistaParcelado, formatBRL, formatPercent } from '../../../utils/simuladores';
import SimuladorResultado from './SimuladorResultado';

const { Text } = Typography;

function AvistaParceladoForm() {
    const [values, setValues] = useState({
        valor: null,
        descontoPct: null,
        numParcelas: 10,
        jurosMensalPct: 0,
        rentabilidadeMensalPct: 0.8,
    });

    const resultado = useMemo(() => simularAvistaParcelado(values), [values]);

    const onChange = (field) => (val) => {
        setValues((prev) => ({ ...prev, [field]: val }));
    };

    return (
        <div className="simulador-form">
            <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
                Comparamos o valor à vista com o valor presente das parcelas, usando a rentabilidade que seu dinheiro renderia parado.
            </Text>
            <Form layout="vertical">
                <Form.Item label="Valor do produto (preço cheio)">
                    <InputNumber {...currencyInputProps({ min: 0 })} value={values.valor} onChange={onChange('valor')} />
                </Form.Item>
                <Form.Item label="Desconto à vista (%)">
                    <InputNumber
                        {...decimalInputProps(2, { min: 0, max: 99.99, suffix: '%' })}
                        value={values.descontoPct}
                        onChange={onChange('descontoPct')}
                    />
                </Form.Item>
                <Form.Item label="Número de parcelas">
                    <InputNumber
                        min={1}
                        max={48}
                        style={{ width: '100%' }}
                        value={values.numParcelas}
                        onChange={onChange('numParcelas')}
                        inputMode="numeric"
                    />
                </Form.Item>
                <Form.Item label="Juros do parcelamento (% a.m.)" extra="Deixe 0 se for sem juros">
                    <InputNumber
                        {...decimalInputProps(2, { min: 0, suffix: '%' })}
                        value={values.jurosMensalPct}
                        onChange={onChange('jurosMensalPct')}
                    />
                </Form.Item>
                <Form.Item
                    label="Rentabilidade do dinheiro (% a.m.)"
                    extra="Ex.: ~0,8% a.m. ≈ 100% do CDI (ajuste conforme seu investimento)"
                >
                    <InputNumber
                        {...decimalInputProps(2, { min: 0, suffix: '%' })}
                        value={values.rentabilidadeMensalPct}
                        onChange={onChange('rentabilidadeMensalPct')}
                    />
                </Form.Item>
            </Form>

            {resultado && (
                <SimuladorResultado
                    veredicto={resultado.veredicto}
                    stats={[
                        { title: 'Valor à vista', value: formatBRL(resultado.valorAvista) },
                        { title: 'Parcela', value: formatBRL(resultado.parcela) },
                        { title: 'Total parcelado', value: formatBRL(resultado.totalParcelado) },
                        { title: 'Valor presente', value: formatBRL(resultado.valorPresenteParcelas) },
                        ...(resultado.descontoMinimoBreakEven != null
                            ? [{ title: 'Desconto p/ empatar', value: formatPercent(resultado.descontoMinimoBreakEven) }]
                            : []),
                    ]}
                />
            )}
        </div>
    );
}

export default AvistaParceladoForm;
